import useStateWithChange from '@/shared/hooks/useStateWithChange.ts'
import useNestedArrayChangeCallbacks from '@/shared/hooks/useNestedArrayChangeCallbacks.ts'
import { memo, useEffect } from 'react'
import textChartUtils from '@/pages/Dashboards/Charts/TextChart/textChart.utils'
import TextChartSettingContent from '@/pages/Dashboards/Charts/TextChart/TextChartSetiingSidePage/TextChartSettingContent'
import { ITextWidget } from '@/pages/Dashboards/dashboards.types'
import { ITextWidgetSettings } from '@/pages/Dashboards/Charts/TextChart/textChart.types'

interface IProps {
  onChange: (val: ITextWidgetSettings) => void
  widget: ITextWidget
}

const UpdateTextWidgetContent = (props: IProps) => {
  const [settings, setSettings, handleChange] = useStateWithChange(props.widget.configuration.settings)

  useEffect(() => {
    props.onChange(settings)
  }, [settings, props.onChange])

  const {
    handleElementDelete: handleParameterTextDelete,
    handleElementUpdate: handleParameterTextUpdate,
    handleCreateNewElement: handleParameterTextCreate,
  } = useNestedArrayChangeCallbacks({
    nestedArrayKey: 'parametersText',
    sourceObjectSetter: setSettings,
    newEntityGenerator: textChartUtils.generateEmptyParameterText,
  })

  return (
    <div className="flex-lines gap16">
      <h4 className="text-heading-4">Настройки виджета: Текст и переменные</h4>
      <TextChartSettingContent
        settings={settings}
        onChange={handleChange}
        handleParameterTextCreate={handleParameterTextCreate}
        handleParameterTextDelete={handleParameterTextDelete}
        handleParameterTextUpdate={handleParameterTextUpdate}
      />
    </div>
  )
}

export default memo(UpdateTextWidgetContent)
